import React, { createRef, useEffect } from "react";
import { usePositionedScreenContext } from "../../PositionedScreen";

const FullNode = ({ node, className, style, renderLayout, handlers }) => {
  const { elementRefs } = usePositionedScreenContext();

  if (elementRefs?.current && node?.id) {
    if (!elementRefs.current[node.id]) {
      elementRefs.current[node.id] = createRef();
    }
  }
  useEffect(() => {
    const el = elementRefs.current[node.id]?.current;
    if (el) {
      el.setAttribute("data-type", node.type);
    }
  }, [elementRefs, node.id, node.type]);

  return (
    <div
      ref={elementRefs.current[node.id]}
      key={node.id}
      title={node.type}
      className={className}
      style={{ ...style, height: "calc(100% - 36px)" }}
      draggable={false}
      {...handlers}
    >
      {renderLayout(node.children)}
    </div>
  );
};

export default FullNode;
